<template>
  <section class="container">
    <ol class="breadcrumb m-0 d-flex justify-content-end">
      <li class="breadcrumb-item"><a href="#">Início</a></li>
      <li class="breadcrumb-item"><a href="#">PB</a></li>
      <li class="breadcrumb-item active">João Pessoa</li>
    </ol>

    <h2 class="fw-bold my-2">FIAT PUNTO Attractive 1.4 (Flex) - 2020/2022</h2>

    <div class="card">
      <div class="row">
        <div class="col-lg-8">
          <Slider :slides="carouselSlides" />

        <h3>Detalhes do Veículo</h3>
        <ul class="list-group">
          <li  class="list-group-item"><strong>Modelo:</strong> FIAT PUNTO Attractive</li>
          <li  class="list-group-item"><strong>Ano/Modelo:</strong> 2020/2022</li>
          <li  class="list-group-item"><strong>Combustível:</strong> Flex</li>
          <li  class="list-group-item"><strong>Câmbio:</strong> Manual</li>
          <li  class="list-group-item"><strong>Cor:</strong> Branco</li>
          <li  class="list-group-item"><strong>Quilometragem:</strong> 35.000 km</li>
          <li  class="list-group-item"><strong>Carroceria:</strong> Hatch</li>
          <li  class="list-group-item"><strong>Motorização:</strong> 1.4</li>
          <li  class="list-group-item"><strong>Status:</strong> Seminovo</li>
        </ul>
      </div>
    </div>

      <!-- Vehicle Details -->
      <div class="col-lg-4">
        <div class="row mt-4">
      <div class="col-lg-6">
        <span class="text-primary fs-4 fw-bold">R$ 80.000,00</span>
        <h3>Informações do Proprietário</h3>
        <p><strong>Nome:</strong> João Silva</p>
        <button class="btn btn-outline-primary" @click="showContact">Mostrar Número</button>
        <p v-if="contactVisible"><strong>Telefone:</strong> (99) 99999-9999</p>
      </div>
      <div class="col-lg-6 text-end">
        <h3>Ações</h3>
        <button class="btn btn-primary me-2"><i class="fa fa-share"></i> Compartilhar</button>
        <button class="btn btn-success"><i class="fa fa-comments"></i> Chamar no Chat</button>
      </div>
    </div>
        
      </div>
    </div>

    <!-- Features and Options -->
    <div class="row mt-4">
      <div class="col-lg-6">
        <h3>Características</h3>
        <ul class="list-group">
          <li class="list-group-item">4 Portas</li>
          <li class="list-group-item">Flex</li>
          <li class="list-group-item">Direção Elétrica</li>
          <li class="list-group-item">Airbags Frontais</li>
        </ul>
      </div>
      <div class="col-lg-6">
        <h3>Opcionais</h3>
        <ul class="list-group">
          <li class="list-group-item">Ar-Condicionado</li>
          <li class="list-group-item">Vidros Elétricos</li>
          <li class="list-group-item">Rodas de Liga Leve</li>
          <li class="list-group-item">Câmera de Ré</li>
        </ul>
      </div>
    </div>

    <!-- Owner Info and Interaction -->
    

    <!-- Related Vehicles -->
    <div class="mt-5">
      <h3>Veículos Relacionados</h3>
      <div class="row">
        <div class="col-lg-3" v-for="(related, index) in relatedVehicles" :key="index">
          <div class="card">
            <img :src="related.image" class="card-img-top" :alt="related.title">
            <div class="card-body">
              <h5 class="card-title">{{ related.title }}</h5>
              <p class="card-text text-primary">R$ {{ related.price }}</p>
              <a href="#" class="btn btn-outline-primary">Ver Detalhes</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Slider from "@/components/Slider.vue";

export default {
  components: {
    Slider,
  },
  data() {
    return {
      contactVisible: false,
      relatedVehicles: [
        { title: "Volkswagen Gol 1.0", price: "50.000,00", image: "related1.jpg" },
        { title: "Chevrolet Onix 1.4", price: "65.000,00", image: "related2.jpg" },
        { title: "Renault Kwid Zen", price: "55.000,00", image: "related3.jpg" },
        { title: "Ford Fiesta 1.6", price: "60.000,00", image: "related4.jpg" },
      ],
      carouselSlides: [
        {
          image: "https://s2-autoesporte.glbimg.com/vrqqulLfsaGu9BIwe-Y7x-BkDTs=/0x0:1920x1280/280x160/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2024/t/o/FCJW3lSoal9CuOUbaFiw/toyota-rav4-phev-1-frente-3-4.jpg",
          title: "",
          description: "",
          buttonText: "",
          buttonLink: "#",
          link: "#",
          align: "center",
        },
        {
          image: "https://s2-autoesporte.glbimg.com/vrqqulLfsaGu9BIwe-Y7x-BkDTs=/0x0:1920x1280/280x160/smart/filters:strip_icc()/i.s3.glbimg.com/v1/AUTH_cf9d035bf26b4646b105bd958f32089d/internal_photos/bs/2024/t/o/FCJW3lSoal9CuOUbaFiw/toyota-rav4-phev-1-frente-3-4.jpg",
          title: "",
          description: "",
          buttonText: "",
          buttonLink: "#",
          link: "#",
          align: "right",
        },
      ],
    };
  },
  methods: {
    showContact() {
      this.contactVisible = true;
    },
  },
};
</script>

<style scoped>

</style>
